/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';
import { QUERY } from 'components/NavigationList';
import { withRouter } from 'app/context/Router';
import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';

import type { NavigationList } from 'queries/__generated__/NavigationList';

type Props = {
  data: ReactApolloData<NavigationList>,
  loading: boolean,
  location: *,
  router: *,
};

class GroupsIndexHandler extends React.Component<Props> {
  componentWillMount() {
    const sections = idx(this.props.data, _ => _.me.navigationSections);

    if (sections) {
      this.redirect(sections);
    }
  }

  componentWillReceiveProps(nextProps: Props) {
    const sections = idx(this.props.data, _ => _.me.navigationSections);
    const nextSections = idx(nextProps.data, _ => _.me.navigationSections);

    if (!sections && nextSections) {
      this.redirect(nextSections);
    }
  }

  redirect(sections: *) {
    const { router } = this.props;
    const { query } = router.location;

    // Get the first item of the navigation list
    const section = sections.find(s => s.items.length > 0);

    if (section) {
      const item = section.items[0];

      if (item.__typename === 'Class') {
        router.replace({ pathname: `/classes/${item.name}`, query });
        return;
      }

      if (item.__typename === 'Organization') {
        router.replace({ pathname: `/organizations/${item.id}`, query });
        return;
      }
    }

    // current user has no classes or organization then display the null view.
    router.replace({ pathname: `/classes/start`, query });
  }

  render() {
    return <CenteredLoadingIndicator />;
  }
}

const withNavigation = graphql(QUERY, {
  options: () => ({ notifyOnNetworkStatusChange: true }),
});

export { GroupsIndexHandler };
export default withRouter(withNavigation(GroupsIndexHandler));
